var map = {
	"app/_layout/app-basic/app-basic-layout.module": [
		"./src/app/_layout/app-basic/app-basic-layout.module.ts",
		"app-basic-layout.module"
	],
	"app/_layout/app-public/app-public-layout.module": [
		"./src/app/_layout/app-public/app-public-layout.module.ts",
		"app-public-layout.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main